import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '250px 150px 1fr',
    gridColumnGap: '1rem',
    marginBottom: '0.75rem'
  },

  headerContainer: {
    position: 'sticky',
    top: '0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    cursor: 'default'
  },

  itemHeader: {
    marginBottom: '0.5rem',
    fontSize: theme.size.sm
  },

  separator: {
    padding: '0 0 0.5rem 0',

    '& > div': {
      height: '1px',
      background: '#F1F1F1'
    }
  },

  itemRow: {
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  icon: {
    display: 'flex',
    alignItems: 'center'
  },
  titleCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  }
}))

export default useStyles
